// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M8Oe","name":"styles_name__37GU8","phone":"styles_phone__1zAm4"};